export default [
  {
    title: 'مدیریت زیره گپ',
    icon: 'bx bx-award',
    children: [
      {
        title: 'گروه های چت',
        route: { name: 'messageGroups' },
        resource: 'MessageGroupManager',
        action: 'show',
      },

      {
        title: 'پیام های گزارش شده',
        route: { name: 'messageReports' },
        resource: 'MessageManager',
        action: 'show',
      },
      {
        title: 'پیام های پین شده',
        route: { name: 'messagePin' },
        resource: 'MessageManager',
        action: 'show',
      },
     {
        title: ' پیام های زمان بندی شده',
        route: { name: 'scheduleMessage' },
        resource: 'ChallengeManager',
        action: 'show',
      },

    ]
  }
]